export default {
    intCodigoRetorno: 0,
    isError: false,
    isTokenError: false,
    strErrorMessage: '',
    vchVersaoParametros: null,
    ChrCodigoOperador: '12345678',
    ChrCodigoPonto: '123456  ',
    ChrSerial: '999000000001',
    Cliente_ID: 1,
    LastAccess: '/Date(1549637227306-0300)/',
    LoginLE: '0',
    Session_ID: 'JBWEBETICKET_1',
    TokenLE: 'TESTEDEV',
    WalletBalance: 1000,
    arrTipoJogo: [
      {
        intCodigoRetorno: 0,
        isError: false,
        isTokenError: false,
        strErrorMessage: '',
        vchVersaoParametros: null,
        lstComposicao: [],
        lstComposicaoCotacao: [],
        lstDiaSemana: [],
        lstExtracaoExcecao: [
          9,
          10,
          11,
          12,
          18,
          20,
          21,
          31,
          36,
          48,
          59,
          63,
          64,
          65,
          66,
          67,
          68,
          69,
          70
        ],
        lstExtracaoValor: [],
        lstFatorExponencial: [],
        lstPremioExtracao: [
          {
            tnyExtracao: 0,
            tnyPremioMaior: 6,
            tnyPremioMenor: 1
          }
        ],
        lstPremioFixo: [
          {
            sntFatorAdcional: 1,
            vchDescImpressao: '1.6',
            vchPremioFixo: '1.6'
          }
        ],
        lstSubTipo: [],
        lstTamanhoFixo: [
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 30000,
            tnyTamanho: 20
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 20000,
            tnyTamanho: 22
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 15000,
            tnyTamanho: 24
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 10000,
            tnyTamanho: 26
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 8000,
            tnyTamanho: 28
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 5000,
            tnyTamanho: 30
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 2900,
            tnyTamanho: 32
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 2000,
            tnyTamanho: 34
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 1500,
            tnyTamanho: 36
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 1000,
            tnyTamanho: 38
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 700,
            tnyTamanho: 40
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 150,
            tnyTamanho: 50
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 48,
            tnyTamanho: 60
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 18,
            tnyTamanho: 70
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 8,
            tnyTamanho: 80
          },
          {
            numValorMaximoAposta: 50,
            numValorPagoTamanhoFixo: 1,
            tnyTamanho: 90
          }
        ],
        lstTipoJogoComposto: [],
        lstTipoJogoRepeticao: [],
        objTipoJogo: {
          Imagem_ID: 0,
          Mensagem_ID: 0,
          bitApenasPremioComPonto: 0,
          bitApenasPremiosFixos: 1,
          bitApenasSurpresinha: 0,
          bitApostaLinhaUnica: 0,
          bitApostaUnica: 0,
          bitBolao: 0,
          bitBrinde: 0,
          bitConcurso: 1,
          bitDefesaOnline: 0,
          bitEsconderNoMenu: 0,
          bitFatorExponencial: 0,
          bitInstantaneo: 0,
          bitME: 0,
          bitMultQtdPremios: 0,
          bitMultQtdSequencia: 0,
          bitMultQtdSequenciaUnidade2: 0,
          bitOnline: 0,
          bitOrdenacao: 1,
          bitOrdenacaoImpressao: 1,
          bitPermiteMultiploValorFixo: 0,
          bitPermiteOffline: 0,
          bitPermiteSequencia: 0,
          bitPermiteSequenciaUnidade2: 0,
          bitPermiteT: 1,
          bitPredatavel: 1,
          bitRepeticaoDescarga: 0,
          bitRifa: 0,
          bitSurpresinha: 1,
          bitTipoJogoUnico: 0,
          bitValidacaoExterna: 0,
          chrSeparador: 'x',
          intQtdMaxPule: 0,
          intQtdMaxSequencia: 0,
          numValorFixo: 0,
          numValorMinimoAposta: 1,
          sntFatorFixo: 1,
          sntIDTabelaInversao: 0,
          sntOrdemTerminal: 27,
          sntQtdItensLinha: 99,
          sntTipoJogo: 666,
          sntTipoJogoExibicao: 666,
          sntTipoJogoSistema: 666,
          strPremioSeco: ' ',
          tnyCombinacao: 0,
          tnyNumeroMax: 60,
          tnyNumeroMin: 1,
          tnyQtdFixaPremio: 0,
          tnyQtdItensApuracao: 0,
          tnyQtdMaximaPremio: 0,
          tnyQtdMinimaPremio: 0,
          tnyQtdRepPermitidas: 0,
          tnyTamanhoMax: 90,
          tnyTamanhoMin: 20,
          tnyTipoCalculoRepeticao: 1,
          tnyTipoCalculoSerie: 2,
          tnyTipoInversao: 0,
          tnyTipoRateioPadrao: 0,
          tnyUnidade: 2,
          tnyUnidadeImpressao: 2,
          vchCodigoTipoJogoIntegracao: '',
          vchNome: 'Super 6',
          vchPremioPadrao: '',
          vchSigla: 'S'
        }
      }
    ],
    objConcursos: {
      intCodigoRetorno: 0,
      isError: false,
      isTokenError: false,
      strErrorMessage: '',
      vchVersaoParametros: null,
      arrConcursos: [
        {
          intLimiteVenda: 1140,
          intNumeroConcurso: 13022019,
          sdtData: '2019-02-13 00:00',
          sntConcurso: 6,
          sntTipojogo: 666,
          tnyExtracao: 35,
          vchDescricao: 'SENINHA',
          vchMensagemConcurso: 'Teste'
        },
        {
          intLimiteVenda: 1140,
          intNumeroConcurso: 16022019,
          sdtData: '2019-02-16 00:00',
          sntConcurso: 6,
          sntTipojogo: 666,
          tnyExtracao: 35,
          vchDescricao: 'SENINHA',
          vchMensagemConcurso: 'Teste '
        },
        {
          intLimiteVenda: 1140,
          intNumeroConcurso: 23022019,
          sdtData: '2019-02-23 00:00',
          sntConcurso: 6,
          sntTipojogo: 666,
          tnyExtracao: 35,
          vchDescricao: 'SENINHA',
          vchMensagemConcurso: 'Teste'
        },
        {
          intLimiteVenda: 1140,
          intNumeroConcurso: 27022019,
          sdtData: '2019-02-27 00:00',
          sntConcurso: 6,
          sntTipojogo: 666,
          tnyExtracao: 35,
          vchDescricao: 'SENINHA',
          vchMensagemConcurso: 'Teste'
        },
        {
          intLimiteVenda: 1439,
          intNumeroConcurso: 2,
          sdtData: '2019-02-09 00:00',
          sntConcurso: 8,
          sntTipojogo: 50,
          tnyExtracao: 70,
          vchDescricao: 'Outro Concurso',
          vchMensagemConcurso: 'teste'
        }
      ]
    }
  }


// WEBPACK FOOTER //
// ./src/mocking/new-session.js